// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EmojisStickersButton__button-cfc4a6 {
  margin: 0 8px 0 16px;
}

.EmojisStickersButton__popover-ff9347 {
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatFooter/InputPanel/InputSection/EmojisStickersButton/EmojisStickersButton.styles.m.css"],"names":[],"mappings":"AAAA;EACE,oBAAA;AACF;;AACA;EACE,UAAA;AAEF","sourcesContent":[".button {\n  margin: 0 8px 0 16px;\n}\n.popover {\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `EmojisStickersButton__button-cfc4a6`,
	"popover": `EmojisStickersButton__popover-ff9347`
};
module.exports = ___CSS_LOADER_EXPORT___;
